import { Forms } from 'sites/types';
import { FormFieldConfig } from 'ui/forms/custom/types';

import { commonForms } from '../common/forms';

const addressForm: Array<Array<FormFieldConfig>> = [
  [
    { name: 'firstName', type: 'input', required: true },
    { name: 'lastName', type: 'input', required: true },
  ],
  [{ name: 'companyName', type: 'input' }],
  [{ name: 'address2', type: 'input' }],
  [
    {
      name: 'address1',
      type: 'google-address-look-up',
      required: true,
    },
  ],
  [
    { name: 'city', type: 'input', required: true },
    { name: 'postalCode', type: 'input', required: true },
  ],
  [
    { name: 'stateCode', type: 'dropdown', required: true },
    { name: 'countryCode', type: 'dropdown' },
  ],
];
export const AUForms: Forms = {
  ...commonForms,
  accountAddress: [
    [{ name: 'title', type: 'input', required: true }],
    ...addressForm,
    [{ name: 'phone', type: 'input', inputType: 'tel' }],
    [{ name: 'preferred', type: 'checkbox' }],
  ],
  checkoutAddress: [...addressForm],
  checkoutContactInfo: [
    [
      { name: 'email', type: 'input', inputType: 'email', required: true },
      { name: 'phone', type: 'input', inputType: 'tel', required: true },
    ],
    [{ name: 'emailList', type: 'checkbox' }],
  ],
  checkoutContactInfoNoSubscription: [
    [
      { name: 'email', type: 'input', inputType: 'email', required: true },
      { name: 'phone', type: 'input', inputType: 'tel', required: true },
    ],
  ],
  orderLookUpReturns: [
    [
      {
        name: 'orderNo',
        type: 'input',
        required: true,
      },
    ],
    [{ name: 'orderEmail', type: 'input', inputType: 'email', required: true }],
    [
      {
        name: 'billingPostalCode',
        type: 'input',
        required: true,
      },
    ],
    [
      {
        name: 'returnsOrderExplainerModal',
        type: 'text-to-modal',
        required: true,
      },
    ],
    [
      {
        name: 'submitButton',
        type: 'button',
        buttonType: 'submit',
      },
    ],
  ],
};
